import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PlacementType } from 'api/navigationStyle'
import initialState from './initialState'
import { StyleSettings } from './types'

const slice = createSlice({
  name: 'appNavigationStyle',
  initialState,
  reducers: {
    updatePlacement: (state, action: PayloadAction<PlacementType>) => {
      state.settings.placement = action.payload
      state.hasChanges = true
    },
    updateBackgroundColor: (state, action: PayloadAction<string>) => {
      state.settings.backgroundColor = action.payload
      state.hasChanges = true
    },
    updateDefaultLabelColor: (state, action: PayloadAction<string>) => {
      state.settings.defaultLabelColor = action.payload
      state.hasChanges = true
    },
    updateSelectedLabelColor: (state, action: PayloadAction<string>) => {
      state.settings.selectedLabelColor = action.payload
      state.hasChanges = true
    },
    updateSettings: (state, action: PayloadAction<Partial<StyleSettings>>) => {
      state.settings = {
        ...state.settings,
        ...action.payload,
      }
      state.hasChanges = true
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    resetChanges: state => {
      state.hasChanges = false
    },
    setChanges: state => {
      state.hasChanges = true
    },
    reset: (state, action: PayloadAction<StyleSettings>) => {
      state.settings = action.payload
      state.hasChanges = false
      state.isLoading = false
    },
  },
})

export const reducer = slice.reducer
export const {
  updatePlacement,
  updateBackgroundColor,
  updateDefaultLabelColor,
  updateSelectedLabelColor,
  updateSettings,
  setLoading,
  resetChanges,
  setChanges,
  reset,
} = slice.actions
